import { cn } from "../../lib/utils";

// Deal program tier vocabulary (matches dealer-ui's ScoringProgramType).
export type Tier = "STANDARD" | "SILVER" | "GOLD" | "PLATINUM";

const BASE_CLASS =
  "inline-flex w-fit items-center rounded-md border px-2 py-0.5 text-xs font-bold tracking-wide uppercase";

// Per-tier colors live as tokens in styles/theme.css (no arbitrary hex in
// components). Keyed by the non-STANDARD tiers so adding a Tier member without
// a color is a compile error — the map can't silently drift from the union.
// STANDARD is the base tier and renders no badge (parity with dealer-ui).
const TIER_CLASS: Record<Exclude<Tier, "STANDARD">, string> = {
  GOLD: "border-tier-gold-border bg-tier-gold text-tier-gold-foreground",
  SILVER: "border-tier-silver-border bg-tier-silver text-tier-silver-foreground",
  PLATINUM: "border-tier-platinum-border bg-tier-platinum text-tier-platinum-foreground",
};

interface TierBadgeProperties {
  tier: Tier;
  className?: string;
}

// Renders the deal program tier as a colored badge. The uppercase tier name is
// the accessible indicator (not color alone). STANDARD renders nothing.
export function TierBadge({ tier, className }: TierBadgeProperties) {
  if (tier === "STANDARD") {
    return null;
  }
  return (
    <span data-slot="tier-badge" data-tier={tier} className={cn(BASE_CLASS, TIER_CLASS[tier], className)}>
      {tier}
    </span>
  );
}
